/**
 * The page the app opens on.
 *
 * Overview since 2026-10-15 (owner): it took the Dashboard's row at the top of
 * the menu and the Dashboard (pages/Home) left the menu. Signing in, signing up,
 * joining a workspace, "/" and every unknown URL land here. Before, the first
 * three landed on /campaigns and "/" was the Dashboard.
 *
 * @module config/startPage
 */
export const START_PAGE = "/overview";
